export const useUserSettingsPending = () => {
  const route = useRoute();

  function clearHighlightQueryParam() {
    const query = { ...route.query };

    delete query.highlight;

    return navigateTo({
      query,
      replace: true,
    });
  }

  function updateHighlightQueryParam(highlight: string) {
    const query = { ...route.query };

    query.highlight = highlight;

    return navigateTo({
      query,
      replace: true,
    });
  }

  async function checkPending(refsForPendencyList: any) {
    const { isWithinMigrationPeriod } = useFeatureFlagsNew();
    const { redirectToPendingSettings } = useUserValidations();

    const getPendencyList = refsForPendencyList.filter((item: any) => {
      return item?.hasPendency;
    });

    if (!getPendencyList.length) {
      clearHighlightQueryParam();

      if (isWithinMigrationPeriod.value) {
        await redirectToPendingSettings();
      }

      return;
    }

    // @ts-ignore
    const currentEditing = getPendencyList.find(({ isEditing }) => !!isEditing);

    if (currentEditing) {
      return updateHighlightQueryParam(currentEditing.name);
    }

    const currentHighlight = getPendencyList.find(
      // @ts-ignore
      ({ name }) => name === route.query.highlight,
    );

    if (currentHighlight?.hasPendency) {
      return;
    }

    const [currentPending] = getPendencyList;

    if (!currentPending) {
      return;
    }

    if (!currentPending.isEditing) {
      currentPending.toggleEdit();
    }

    return updateHighlightQueryParam(currentPending.name);
  }

  return {
    checkPending,
  };
};
